import { createAsyncThunk } from '@reduxjs/toolkit';
import { PayoutService } from '../services/payout.service';
import { PayoutFormValues } from '../types/payout.types';
import { showCriticalAlert } from './common.actions';
import i18n from '../i18n';

export const updatePayout = createAsyncThunk(
    'payout/updatePayout',
    async (payoutData: PayoutFormValues, { rejectWithValue, dispatch }) => {
        try {
            const updatedPayout = await PayoutService.updatePayout(payoutData);
            return updatedPayout;
        } catch (error) {
            dispatch(showCriticalAlert(i18n.t('epic.common.network.error')));
            return rejectWithValue(
                error instanceof Error ? error.message : 'Unknown error occurred'
            );
        }
    }
);

export const fetchPayout = createAsyncThunk(
    'payout/fetchPayout',
    async (_, { rejectWithValue, dispatch }) => {
        try {
            const payoutData = await PayoutService.fetchPayout();
            return payoutData;
        } catch (error) {
            dispatch(showCriticalAlert(i18n.t('epic.common.network.error')));
            return rejectWithValue(
                error instanceof Error ? error.message : 'Unknown error occurred'
            );
        }
    }
);
